
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import axios from "axios";
import EnterButton from "@/components/EnterButton.vue";
import CancelButton from "@/components/CancelButton.vue";
import Header from "@/components/Header.vue";
import Edit from "@/javascripts/image/edit";

export default defineComponent({
  name: "Write",
  components: {
    EnterButton,
    CancelButton,
    Header,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toEdit = () => router.push({ name: "edit" });
    const toPost = () => router.push({ name: "post" });

    const edit = new Edit();

    const { imageEditor } = useGlobalStore();
    const selectedImage = imageEditor.selectedImage;
    if (!selectedImage) {
      toSelect();
      return;
    }
    let canvasImgSrc = "";
    if (imageEditor.isSelectedImageUploaded()) {
      // アップロード画像を使用する場合
      canvasImgSrc = selectedImage.src as string;
    } else {
      // 選択画像を使用する場合
      canvasImgSrc = "/app/assets/img/base_illust/original/";
      canvasImgSrc += selectedImage.fileName;
    }
    const trimPoint = imageEditor.trimPoint;
    const savedEditData = imageEditor.editData;

    const dataFontSrc = "/app/assets/css/image/icomoon-font.css";

    const writeText = ref<String>("");

    onMounted(() => {
      edit.setupWriteView();
    });

    onUnmounted(() => {});

    function onClickCompleteBtn() {
      complete();
    }

    async function complete() {
      // canvas側の更新
      edit.completeEdit(writeText.value as string);

      // store側への画像保存
      const completedImage = edit.getCompletedImage();
      imageEditor.completeEditing(completedImage);

      // store側への編集情報保存
      save();

      // 画像アップロード: 編集完了と1:1でアップロードするため、ここで行う
      await uploadImage(completedImage);

      // 遷移
      toPost();
    }

    function save(): boolean {
      const editData = edit.getEditData();
      if (!editData) {
        return false;
      }
      imageEditor.saveEditData(editData);
      return true;
    }

    async function uploadImage(image: string) {
      const ImageUploadAPI = "/api/image/upload";
      const params = new FormData();
      params.append("image", image);

      let imageId = null;
      await axios
        .post(ImageUploadAPI, params)
        .then(function (response) {
          const data = response.data;
          if (data.result == true) {
            imageId = data.image_id;
            imageEditor.completeUploading(imageId);
          } else {
            alert("画像のアップロードに失敗しました。");
          }
        })
        .catch(function (error) {
          alert(error);
        });

      return imageId;
    }

    return {
      toEdit,
      writeText,
      canvasImgSrc,
      trimPoint,
      savedEditData,
      dataFontSrc,
      onClickCompleteBtn,
    };
  },
});
